import React, { useEffect, useState } from "react";
import { db } from "../../firebaseConfig";
import {
  collection,
  query,
  orderBy,
  getDocs,
  deleteDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import classes from "./Account.module.css";
import default_profile_pic from "../../assets/default_pic.png"
import { FiSettings } from "react-icons/fi"; // 👈 add this at top


const Account = ({ user }) => {
  const navigate = useNavigate();
  const [maps, setMaps] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selectMode, setSelectMode] = useState(false);
  const [profile, setProfile] = useState(null);

  // Fetch profile info from Firestore
  useEffect(() => {
    if (!user) return;
    const fetchProfile = async () => {
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        setProfile(userDoc.data());
      }
    };
    fetchProfile();
  }, [user]);

  // Fetch user maps
  useEffect(() => {
    if (!user) return;

    const fetchMaps = async () => {
      const q = query(
        collection(db, "users", user.uid, "mindmaps"),
        orderBy("createdAt", "desc")
      );
      const snap = await getDocs(q);
      const docs = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setMaps(docs);
    };

    fetchMaps();
  }, [user]);

  // Group maps by date
  const grouped = maps.reduce((acc, m) => {
    const dateKey =
      m.createdAt?.toDate().toLocaleDateString() || "Unknown Date";
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(m);
    return acc;
  }, {});

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleDelete = async () => {
    for (const id of selected) {
      await deleteDoc(doc(db, "users", user.uid, "mindmaps", id));
    }
    setMaps(maps.filter((m) => !selected.includes(m.id)));
    setSelected([]);
    setSelectMode(false);
  };

  return (
    <div className={classes.container}>
      {/* Profile Section */}
      <div className={classes.profileCard}>
        <div className={classes.settingsIcon} onClick={() => navigate("/settings")}>
    <FiSettings size={22} />
  </div>
        <div className={classes.avatarWrapper}>
          <img
            src={profile?.photoURL || default_profile_pic}
            alt="Profile"
            className={classes.avatar}
          />
          <button className={classes.changePicBtn}>Change</button>
        </div>
        <div className={classes.userDetails}>
          <h2 className={classes.username}>
            {profile?.username || "Anonymous User"}
          </h2>
          <p className={classes.email}>{profile?.email || user?.email}</p>
          <p className={classes.bio}>
            {profile?.bio || "This is a sample bio. You can update it later!"}
          </p>
          <p className={classes.dateJoined}>
            Joined:{" "}
            {profile?.createdAt
              ? profile.createdAt.toDate().toLocaleDateString()
              : "Unknown"}
          </p>
        </div>
      </div>

      <hr className={classes.divider} />

      {/* Mindmaps Section */}
      <div className={classes.headerRow}>
        <h2 className={classes.heading}>My Mindmaps</h2>
        <button
          className={classes.selectBtn}
          onClick={() => {
            setSelectMode(!selectMode);
            setSelected([]);
          }}
        >
          {selectMode ? "Exit Select Mode" : "Select"}
        </button>
      </div>
      <hr className={classes.divider} />

      {selectMode && selected.length > 0 && (
        <div className={classes.toolbar}>
          <span>{selected.length} selected</span>
          <button className={classes.deleteBtn} onClick={handleDelete}>
            🗑 Delete
          </button>
        </div>
      )}

      {Object.entries(grouped).map(([date, dayMaps]) => (
        <div key={date} className={classes.group}>
          <h3 className={classes.dateHeader}>{date}</h3>
          <div className={classes.grid}>
            {dayMaps.map((m) => (
              <div
                key={m.id}
                className={`${classes.card} ${
                  selected.includes(m.id) ? classes.selected : ""
                }`}
                onClick={() =>
                  selectMode
                    ? toggleSelect(m.id)
                    : navigate("/ideamap", { state: { graphData: m.graphData } })
                }
              >
                <div className={classes.thumbnail}>
                  <p className={classes.thumbQuestion}>
                    {m.graphData?.nodes?.[0]?.question || "Untitled"}
                  </p>
                </div>
                <div className={classes.cardBody}>
                  <strong className={classes.title}>{m.title}</strong>
                  <p className={classes.caption}>
                    {m.graphData?.nodes?.[0]?.question}
                  </p>
                  <p className={classes.time}>
                    {m.createdAt?.toDate().toLocaleTimeString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {maps.length === 0 && <p>No maps yet!</p>}
    </div>
  );
};

export default Account;
